module.exports = __webpack_public_path__ + "img/widget.8c226dff.png";